import { render, staticRenderFns } from "./ontick-discount-badge.component.vue?vue&type=template&id=8681b574&scoped=true"
import script from "./ontick-discount-badge.component.vue?vue&type=script&lang=js"
export * from "./ontick-discount-badge.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-discount-badge.component.vue?vue&type=style&index=0&id=8681b574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8681b574",
  null
  
)

export default component.exports